module.exports = __webpack_public_path__ + "10b997e91c790bc6dde3684ffb87bc29.svg";